<template>
  <div class="form-group mb-3">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'FormGroup',
  };
</script>

<style scoped></style>
